// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Fira Sans", sans-serif;
  }
  
  main {
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
  }
  
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(223, 223, 223);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .popup-inner {
    position: relative;
    padding: 32px;
    width: 100%;
    max-width: 400px;
    background-color: white;
  }
  
/*   
  button{
    background-color: rgb(7, 112, 177);
    padding: 15px 30px;
    color: #fff;
    font-size: 17px;
    cursor: pointer;
    border: none;
    border-radius: 3px;
  }
   */
  .popup-inner .close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background-color: rgb(4, 77, 120);
    padding: 5px;
  }
  
  h3{
    text-align: center;
    font-size: 22px;
  }
  
  h6{
    font-weight: 500;
    font-size: 18px;
    margin: 20px;
    margin-top: 40px;
  }`, "",{"version":3,"sources":["webpack://./src/components/profile.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;AAEF;;;;;;;;;;IAUI;EACF;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB","sourcesContent":["* {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    font-family: \"Fira Sans\", sans-serif;\r\n  }\r\n  \r\n  main {\r\n    padding: 32px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 100vh;\r\n  }\r\n  \r\n  .popup {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgb(223, 223, 223);\r\n    padding: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .popup-inner {\r\n    position: relative;\r\n    padding: 32px;\r\n    width: 100%;\r\n    max-width: 400px;\r\n    background-color: white;\r\n  }\r\n  \r\n/*   \r\n  button{\r\n    background-color: rgb(7, 112, 177);\r\n    padding: 15px 30px;\r\n    color: #fff;\r\n    font-size: 17px;\r\n    cursor: pointer;\r\n    border: none;\r\n    border-radius: 3px;\r\n  }\r\n   */\r\n  .popup-inner .close-btn {\r\n    position: absolute;\r\n    top: 16px;\r\n    right: 16px;\r\n    background-color: rgb(4, 77, 120);\r\n    padding: 5px;\r\n  }\r\n  \r\n  h3{\r\n    text-align: center;\r\n    font-size: 22px;\r\n  }\r\n  \r\n  h6{\r\n    font-weight: 500;\r\n    font-size: 18px;\r\n    margin: 20px;\r\n    margin-top: 40px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
